import {
    Checkbox,
    Dialog,
    FormControl,
    FormControlLabel,
    FormHelperText,
    SwipeableDrawer,
    Switch,
    TextField,
} from '@material-ui/core';
import { decimalFix } from '../../portfolios/utils';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { useState, useEffect, ChangeEvent, useCallback } from 'react';
import { useDispatch, connect } from 'react-redux';
import { RouteComponentProps, StaticContext } from 'react-router';
import {
    RedemptionAPIDataKeyType,
    RedemptionSchemeOptionsType,
} from '../../../../redux-store/reducers/redemption';
import en from '../../../../lang/en-us';
import { favLogos } from '../../../../logo/logos';
import { redeemScheme } from '../../../../redux-store/actions/commercialTransactions';
import { calculateAmountFromUnits, calculateUnitsFromAmount, DisplayBlock } from './HelperBlocks';
import { SelectBank } from './SelectBank';
import { bankDetailsInitState, BankDetailsType } from '../../../../hooks/useBank';
import { IsAllow } from '../../../../redux-store/types/portfolio';
import { SubmitButton, SubmitButtonWithLoader } from '../../../../lib/Button';
import { isMobileDevice, OTP_ACTIONS, REDEMPTION } from '../../../../utils/constants';
import { getNewSchemeDetail } from '../../../../redux-store/actions/commercialTransactions';
import {
    schemeDetailArrayIndices,
    schemeDetailsNewType,
    schemeDetailsRequestType,
    schemeDetailsResponseType,
} from '../../../../redux-store/types/commercialTransactions';
import { SwitchBy } from '../Switch/SwitchInvestment';
import { KYCCheck } from '../../../common/KYCCheck';
import { CommercialRootPath } from '../routeConfig';
import { RedeemPaths } from './routes';
import { formatAsIndianCurrency } from '../../../../utils/currency';
import { shouldAllowDecimal, TRXN_TYPE_MAP } from '../utils';
import FatcaCheck from '../../../common/FatcaCheck';
import { FaqLink } from '..';
import { IFSCError } from '../IFSCError';
import { RtaSchemeLoadingDialog } from '../AdditionalPurchase/ap-invest';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';

const { dbCommercial, common } = en;

type MatchParams = {
    folioNo: string;
};
type StateParams = {
    additionalPurchaseFolio?: any;
    reqId?: string;
    otpRef?: string;
    apiPayload?: {
        data: [RedemptionAPIDataKeyType];
    };
};
function RedemptionMain(
    props: RouteComponentProps<MatchParams, StaticContext, StateParams> & {
        getNewSchemeDetail: ({
            isin,
            amcCode,
        }: schemeDetailsRequestType) => Promise<schemeDetailsResponseType>;
        sendPhoneOTP: any;
    },
) {
    const Amount = dbCommercial.redemption.amount;
    const Units = dbCommercial.redemption.units;
    const { additionalPurchaseFolio } = props.location.state || {};
    if (!additionalPurchaseFolio) {
        props.history.replace(`${CommercialRootPath}${RedeemPaths.Redeem}`);
        return null;
    }
    const amcCode = new URLSearchParams(props.location.search).get('amc');
    const [newSchemeDetails, setNewSchemeDetails] = useState<schemeDetailsNewType | null>(null);
    const {
        folio: folioNo,
        nav,
        availableAmount,
        availableUnits,
        amc,
        schemeName,
        navDate,
        rtaName,
    } = additionalPurchaseFolio;

    const [amount, setAmount] = useState<number>('' as unknown as number);
    const [redeemBy, setRedeemBy] = useState<string>(Amount);
    const [isFullAmount, setisFullAmount] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [schemeLoading, setSchemeLoading] = useState(false);
    const [ifscError, setIfscError] = useState(false);
    const [error, setError] = useState<string>('');
    const [isChecked, setChecked] = useState<{ value: boolean; message: string }>({
        value: false,
        message: '',
    });

    const [bankDetails, setBankDetails] = useState<BankDetailsType>(bankDetailsInitState); //setting bank details to default when no bank is available

    useEffect(() => {
        async function getSchemeDetails() {
            try {
                setSchemeLoading(true);
                const { body = { data: {} as any } }: schemeDetailsResponseType =
                    await props.getNewSchemeDetail({
                        isin: additionalPurchaseFolio.isin,
                        amcCode: !!amcCode ? amcCode : '',
                    });
                setNewSchemeDetails(body.data);
            } catch (err: any) {
                alert(err.message);
                props.history.goBack();
            } finally {
                setSchemeLoading(false);
            }
        }
        getSchemeDetails();
    }, []);

    const handleRedeemAll = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
        checked
            ? redeemBy === Amount
                ? (setAmount(availableAmount), setError(''))
                : (setAmount(availableUnits), setError(''))
            : (setAmount(0), setError(dbCommercial.redemption.errors.invalidAmount));
        setisFullAmount(checked);
    };

    const resetFields = () => {
        setAmount('' as unknown as number);
        setError('');
        if (isFullAmount) setisFullAmount(false);
    };

    const handleAmountChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        if (!shouldAllowDecimal(event.target.value, redeemBy)) {
            return;
        }
        if (event.target.value.length === 0 || event.target.value === '0') {
            redeemBy === Amount
                ? setError(dbCommercial.redemption.errors.invalidAmount)
                : setError(dbCommercial.redemption.errors.invalidUnits);
        }
        const minimumAmount = !!newSchemeDetails
            ? newSchemeDetails[schemeDetailArrayIndices.redemption].redemption.minAmount || 1
            : 1;
        const multiples = !!newSchemeDetails
            ? newSchemeDetails[schemeDetailArrayIndices.redemption].redemption.multiples || 1
            : 1;

        const currentValue = parseFloat(event.target.value);
        if (redeemBy === Amount) {
            setAmount(currentValue);
            if (Number(currentValue) > Number(availableAmount)) {
                setError(`${dbCommercial.redemption.errors.maxAmount} ${availableAmount}`);
            } else if (Number(currentValue) < Number(minimumAmount)) {
                setError(`${dbCommercial.redemption.errors.minAmount} ${minimumAmount}`);
            }
        } else {
            setAmount(currentValue);
            if (currentValue > availableUnits) {
                setError(`${dbCommercial.redemption.errors.maxUnits} ${availableUnits}`);
            }
        }
        if (
            redeemBy === Amount &&
            Number(currentValue) >= Number(minimumAmount) &&
            Number(currentValue) <= Number(availableAmount)
        ) {
            setError('');
        }
        if (redeemBy === Units && currentValue <= availableUnits) {
            setError('');
        }
        if (redeemBy === Amount && Math.trunc(currentValue % Number(multiples)) !== 0) {
            setError(`${dbCommercial.redemption.errors.multiples} ${multiples}`);
        }
        if (
            redeemBy === Amount &&
            currentValue < availableAmount &&
            currentValue > 0 &&
            Number(currentValue) >= Number(minimumAmount)
        )
            setError('');
        if (redeemBy === Units && currentValue < availableUnits && currentValue > 0) setError('');
        isFullAmount ? setisFullAmount(false) : null;
        if (Number(event.target.value) < 0) {
            setError(`${redeemBy} ${dbCommercial.switch.errors.negative}`);
        }
    };

    const handleProceed = () => {
        const amountInUnits = redeemBy === Amount ? calculateUnitsFromAmount(nav, amount) : amount;
        const amountInRupees = redeemBy === Amount ? amount : calculateAmountFromUnits(nav, amount);

        const actionPayload: RedemptionSchemeOptionsType = {
            itemNo: '',
            folio: folioNo,
            isin: additionalPurchaseFolio.isin,
            amount: redeemBy === SwitchBy.Amount && !isFullAmount ? amountInRupees.toString() : '', // not working directly with toFixed when amount only has 2 decimal places
            units:
                redeemBy === SwitchBy.Units || isFullAmount
                    ? isFullAmount
                        ? availableUnits
                        : amountInUnits.toString()
                    : '',
            allUnits: isFullAmount ? IsAllow.YES : IsAllow.No,
            trxnDate: '',
            trxnTime: '',
            userTrxNo: '',
            bank: bankDetails,
        };
        const redemptionDataKey: RedemptionAPIDataKeyType = {
            amc: additionalPurchaseFolio.amc,
            schemeOptions: [actionPayload],
            source: isMobileDevice() ? 'mobile' : 'web',
        };
        async function callApi() {
            setIsLoading(true);
            try {
                const otpPayload = {
                    action: OTP_ACTIONS.redeem,
                };
                const res = await props.sendPhoneOTP(otpPayload);
                props.history.replace(`${CommercialRootPath}${RedeemPaths.RedeemOtp}`, {
                    reqId: res.body.reqId,
                    otpRef: res.body.otpRef,
                    apiPayload: {
                        data: [redemptionDataKey],
                    },
                });
            } catch (err: any) {
                alert(err.message);
            } finally {
                setIsLoading(false);
            }
        }
        if (!!isChecked.value) {
            if (!bankDetails.ifsc) {
                setIfscError(true);
                return;
            }
            callApi();
        } else {
            setChecked({ value: false, message: dbCommercial.errors.termsAndCondition });
        }
    };
    const [show, setShow] = useState<boolean>(false);

    const [touched, setTouched] = useState<boolean>(false);
    const [openDrawer, setDrawer] = useState<boolean>(false);
    return (
        <div className="curved-bg mf-investment mf-payment">
            <KYCCheck
                allowRegistration={{
                    isin: additionalPurchaseFolio.isin,
                    amc: amc,
                }}
            />
            <PanSeedCheckNew
                customPayload={{
                    taxStatus: additionalPurchaseFolio.taxStatus,
                    amc,
                    folio: folioNo,
                    trxnMode: 'FT',
                    trxnType: TRXN_TYPE_MAP.redemption,
                }}
                callBackFn={() => {}}
                triggerCheck={true}
            />
            <FatcaCheck rtaName={rtaName} />
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dbCommercial.redemption.heading}
            </h2>
            <div className="mobile-profile-details mobile_mode" style={{ marginTop: 0 }}>
                <div className="mobile-profile-details-inner">
                    <h4>{dbCommercial.redemption.redeemDetails}</h4>
                    <div className="mobile-profile-details-links">
                        <a onClick={() => setDrawer(true)}>
                            View <img src="/images/right-arrow-purple.svg" alt="icon" />
                        </a>
                    </div>
                </div>
            </div>
            <div className="curved-bg-content redemption-main">
                <div className="mf-investment-left">
                    <div className="investment-mode">
                        <h3>
                            <img src="/images/investment-details.svg" alt="icon" />
                            {dbCommercial.redemption.investmentDetails}
                        </h3>
                        <div className="db-portfolio-chart-toggle">
                            <h5>{dbCommercial.redemption.redeemBy}</h5>
                            <div>
                                <p
                                    style={
                                        redeemBy === Amount ? { opacity: 1, color: '#3A2F5C' } : {}
                                    }
                                >
                                    {dbCommercial.redemption.amount}
                                </p>
                                <Switch
                                    name="toggle-chart"
                                    inputProps={{ 'aria-label': 'toggle-chart' }}
                                    checked={redeemBy === Units}
                                    onChange={() => {
                                        setRedeemBy((type) => (type === Amount ? Units : Amount));
                                        resetFields();
                                    }}
                                />
                                <p
                                    style={
                                        redeemBy === Units ? { opacity: 1, color: '#3A2F5C' } : {}
                                    }
                                >
                                    {dbCommercial.redemption.units}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="investment-details">
                        <div className="investment-amount enter-amount">
                            <h4>
                                {dbCommercial.redemption.enter}
                                {redeemBy === Amount ? Amount : Units}
                            </h4>
                            <TextField
                                id="enter-amount"
                                // onFocusCapture={() => setTouched(false)}
                                onBlur={() => setTouched(true)}
                                variant="outlined"
                                type="number"
                                value={!!amount ? amount : ''}
                                inputProps={{ inputMode: 'numeric' }}
                                error={!!error && touched}
                                // onFocus={() => setTouched(false)}
                                disabled={isFullAmount}
                                // onFocus={() =>
                                //     amount === 0 ? setAmount('' as unknown as number) : null
                                // }
                                helperText={!!touched && !!error ? error : ''}
                                onChange={handleAmountChange}
                            />
                            <div className="enter-amount-values">
                                <p>
                                    {dbCommercial.redemption.redeemable}
                                    {redeemBy === Amount ? Units : Amount}
                                </p>
                                <h5>
                                    {redeemBy === Units
                                        ? formatAsIndianCurrency(
                                              decimalFix(
                                                  calculateAmountFromUnits(
                                                      parseFloat(nav),
                                                      !!amount ? amount : 0,
                                                  ),
                                              ),
                                          )
                                        : decimalFix(
                                              calculateUnitsFromAmount(
                                                  parseFloat(nav),
                                                  !!amount ? amount : 0,
                                              ),
                                          )}
                                </h5>
                            </div>
                            <div className="enter-amount-values">
                                <p>
                                    {dbCommercial.redemption.remaining}
                                    {redeemBy === Amount ? Units : Amount}
                                </p>
                                <h5>
                                    {redeemBy === Units
                                        ? formatAsIndianCurrency(
                                              decimalFix(
                                                  availableAmount -
                                                      calculateAmountFromUnits(
                                                          parseFloat(nav),
                                                          amount,
                                                      ),
                                              ),
                                          )
                                        : decimalFix(
                                              availableUnits -
                                                  calculateUnitsFromAmount(
                                                      parseFloat(nav),
                                                      !!amount ? amount : 0,
                                                  ),
                                          )}
                                </h5>
                            </div>
                        </div>
                        <FormControlLabel
                            control={<Checkbox checked={isFullAmount} onChange={handleRedeemAll} />}
                            label={
                                redeemBy === Amount
                                    ? dbCommercial.redemption.redeemFullAmount
                                    : dbCommercial.redemption.redeemFullUnits
                            }
                            className="inline-checkbox"
                        />
                        <div className="mf-investment-bottom">
                            <div className="disclaimers">
                                <FormControl>
                                    <FormControlLabel
                                        className="inline-checkbox"
                                        control={
                                            <Checkbox
                                                name="terms-conditions"
                                                onChange={() =>
                                                    setChecked((prevState) => ({
                                                        value: !prevState.value,
                                                        message: !!prevState.value
                                                            ? dbCommercial.errors.termsAndCondition
                                                            : '',
                                                    }))
                                                }
                                                checked={isChecked.value}
                                                disabled={isLoading}
                                            />
                                        }
                                        label={
                                            <>
                                                {dbCommercial.exploreMfs.mfInvestment.disclaimers}
                                                <a onClick={() => setShow(!show)}>
                                                    {dbCommercial.exploreMfs.mfInvestment.termsLink}
                                                </a>
                                                {dbCommercial.exploreMfs.mfInvestment.of}
                                                <span>
                                                    {dbCommercial.exploreMfs.mfInvestment.mfCentral}
                                                </span>
                                            </>
                                        }
                                    />
                                    <FormHelperText
                                        style={{ color: 'red', fontSize: 14, textAlign: 'left' }}
                                    >
                                        {isChecked.message}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                            <div className="buttons">
                                <SubmitButtonWithLoader
                                    className="customBtn"
                                    disabled={!!error || !amount}
                                    onClick={handleProceed}
                                    label={dbCommercial.redemption.proceedBtn}
                                    loading={isLoading}
                                    labelWhileLoading="Redeeming..."
                                />
                            </div>
                        </div>
                        <FaqLink section={REDEMPTION} />
                    </div>
                </div>
                <div className="mf-investment-right redemption-right">
                    <div className="heading">
                        <h4>
                            {dbCommercial.redemption.redeemDetails}{' '}
                            <img src="/images/rupee-coin.png" alt="icon" />
                        </h4>
                        <div className="profile-details">
                            <div className="profile-details-info">
                                <p> {dbCommercial.redemption.selectedFolio}</p>
                                <h6>{folioNo}</h6>
                            </div>
                        </div>
                        <p>
                            <img src={`/images/fav-logos/${favLogos[amc]}.svg`} alt="icon" />
                            <h5>{schemeName}</h5>
                        </p>
                    </div>
                    <div className="profile-details">
                        <DisplayBlock
                            title={dbCommercial.redemption.currentValue}
                            value={`₹${availableAmount}`}
                        />
                        <DisplayBlock
                            title={dbCommercial.redemption.totalBalanceUnits}
                            value={`${availableUnits}`}
                        />
                        <DisplayBlock
                            title={dbCommercial.redemption.redeemableUnits}
                            value={`${
                                redeemBy === Amount
                                    ? decimalFix(calculateUnitsFromAmount(parseFloat(nav), amount))
                                    : decimalFix(!!amount ? amount : 0)
                            }`}
                        />
                        <div className="profile-details-info current-nav">
                            <p>{dbCommercial.redemption.currentNav}</p>
                            <div>
                                <h6>{`${formatAsIndianCurrency(nav)}`}</h6>
                                <p>
                                    <img src="/images/calender-icon.svg" alt="icon" />
                                    {dbCommercial.redemption.asOn}
                                    <b>{navDate}</b>
                                </p>
                            </div>
                        </div>
                    </div>
                    <SelectBank
                        redemptionFlag={true}
                        folioNo={folioNo}
                        amc={additionalPurchaseFolio?.amc}
                        handleBankDetails={setBankDetails}
                    />
                </div>
            </div>
            <IFSCError open={ifscError} setOpen={setIfscError} />
            <Dialog fullWidth maxWidth={'lg'} open={show} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.termsConditions}</h2>
                        <a className="close">
                            <img
                                onClick={() => setShow(!show)}
                                src="/images/close-white.svg"
                                alt="icon"
                            />
                        </a>
                    </div>
                    <div className="content-outer">
                        <div className="content-inner">
                            <p>{dbCommercial.termsModal.redemption.info1}</p>
                            <p>{dbCommercial.termsModal.redemption.info2}</p>
                            <p>
                                <b>{dbCommercial.termsModal.redemption.note}</b>
                                {dbCommercial.termsModal.redemption.info3}
                            </p>
                        </div>
                    </div>
                </div>
            </Dialog>
            <RtaSchemeLoadingDialog open={schemeLoading} />
            <SwipeableDrawer
                anchor={'bottom'}
                open={openDrawer}
                onClose={() => setDrawer(false)}
                onOpen={() => setDrawer(true)}
                className="explore-mf-drawer profile-details-drawer"
            >
                <div className="filters-drawer-total">
                    <div className="filters-top">
                        <h5>
                            <img
                                src="/images/right-arrow-long-black.svg"
                                alt="icon"
                                onClick={() => setDrawer(false)}
                            />
                            {dbCommercial.redemption.redeemDetails}
                        </h5>
                    </div>
                    <div className="filters-drawer-content">
                        <div className="profile-details-drawer">
                            <div className="heading">
                                <div className="profile-details">
                                    <div className="profile-details-info">
                                        <p> {dbCommercial.redemption.selectedFolio}</p>
                                        <h6>{folioNo}</h6>
                                    </div>
                                </div>
                                <p>
                                    <img
                                        src={`/images/fav-logos/${favLogos[amc]}.svg`}
                                        alt="icon"
                                    />
                                    <h5>{schemeName}</h5>
                                </p>
                            </div>
                            <div className="profile-details">
                                <DisplayBlock
                                    title={dbCommercial.redemption.currentValue}
                                    value={`₹${decimalFix(availableAmount)}`}
                                />
                                <DisplayBlock
                                    title={dbCommercial.redemption.totalBalanceUnits}
                                    value={`${decimalFix(availableUnits)}`}
                                />
                                <DisplayBlock
                                    title={dbCommercial.redemption.redeemableUnits}
                                    value={`${
                                        redeemBy === Amount
                                            ? decimalFix(
                                                  calculateUnitsFromAmount(parseFloat(nav), amount),
                                              )
                                            : decimalFix(!!amount ? amount : 0)
                                    }`}
                                />
                                <div className="profile-details-info current-nav">
                                    <p>{dbCommercial.redemption.currentNav}</p>
                                    <div>
                                        <h6>{`${formatAsIndianCurrency(nav)}`}</h6>
                                        <p>
                                            <img src="/images/calender-icon.svg" alt="icon" />
                                            {dbCommercial.redemption.asOn}
                                            <b>{navDate}</b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <SelectBank
                                folioNo={folioNo}
                                amc={additionalPurchaseFolio?.amc}
                                handleBankDetails={setBankDetails}
                            />
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
        </div>
    );
}

export default connect(null, { redeemScheme, getNewSchemeDetail, sendPhoneOTP })(RedemptionMain);
